export type AiCoverAspect = 'portrait' | 'landscape';

export const MAX_AI_COVER_PROMPT_LENGTH = 1000;

/** The generation aspect for an export aspect (width/height). */
export function resolveAiCoverAspect(exportAspect: number): AiCoverAspect {
  return exportAspect < 1 ? 'portrait' : 'landscape';
}

export interface ResolveAiCoverRequestInput {
  prompt: string;
  useReference: boolean;
  exportAspect: number;
}

export interface AiCoverRequestValue {
  prompt: string;
  aspect: AiCoverAspect;
  useReference: boolean;
}

export type ResolveAiCoverRequestResult =
  | { ok: true; value: AiCoverRequestValue }
  | { ok: false; code: 'invalid_prompt' };

/**
 * Normalizes the cover-generation dialog's raw inputs into the value sent to
 * `generateMyCoverImage`. Mirrors the backend's own prompt rule (trim, cap at
 * `MAX_AI_COVER_PROMPT_LENGTH`, empty only allowed alongside a reference) so
 * the dialog can reject bad input before round-tripping to the server.
 */
export function resolveAiCoverRequest(
  input: ResolveAiCoverRequestInput,
): ResolveAiCoverRequestResult {
  const prompt = input.prompt.trim().slice(0, MAX_AI_COVER_PROMPT_LENGTH);

  if (!input.useReference && prompt.length === 0) {
    return { ok: false, code: 'invalid_prompt' };
  }

  const aspect = resolveAiCoverAspect(input.exportAspect);

  return { ok: true, value: { prompt, aspect, useReference: input.useReference } };
}
